__turbopack_context__.v({
  "close": "Et2zIa_close",
  "content": "Et2zIa_content",
  "description": "Et2zIa_description",
  "header": "Et2zIa_header",
  "headerLink": "Et2zIa_headerLink",
  "label": "Et2zIa_label",
  "link": "Et2zIa_link",
  "popup": "Et2zIa_popup",
  "propList": "Et2zIa_propList",
  "propRow": "Et2zIa_propRow",
  "scrollArea": "Et2zIa_scrollArea",
  "trigger": "Et2zIa_trigger",
  "value": "Et2zIa_value",
});
